var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRec01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5428 24.7524L44.426 17.8985L20.334 0.43986L21.4502 7.29332L45.5428 24.7524Z",
    fill: "url(#paint0_linear_191_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5428 24.7524L44.426 17.8985L20.334 0.43986L21.4502 7.29332L45.5428 24.7524Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02642 31.3871L2.90448 24.5057L20.3293 0.439958L21.4508 7.32206L4.02642 31.3871Z",
    fill: "url(#paint1_linear_191_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02642 31.3871L2.90448 24.5057L20.3293 0.439958L21.4508 7.32206L4.02642 31.3871Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5259 24.8083L21.3839 7.30878L4.00561 31.3295L28.1476 48.8291L45.5259 24.8083Z",
    fill: "url(#paint2_linear_191_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_2",
    x1: 32.1795,
    y1: 7.94047,
    x2: 34.7523,
    y2: 24.3209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_191_2",
    x1: 4.42832,
    y1: 17.1303,
    x2: 25.9151,
    y2: 13.6271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_191_2",
    x1: 18.5942,
    y1: 36.5988,
    x2: 32.8843,
    y2: 16.8844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRec01);
export default __webpack_public_path__ + "static/media/Rec-01.a36f83a7e718e69015721ed0c8d30db5.svg";
export { ForwardRef as ReactComponent };